<template>


    <div v-bind:class="[{ 'sticky': isSticky }]">

        <div id="flight-result-wrapper">
            <div class="sticky-footer">

                <div v-if="isFlightSel && ifFlightSel==true" @click="ifFlightSel==true?ifFlightSel=false:ifFlightSel=true"
                     class="back-drop-black" :class="{'fade-ani': ifFlightSel}"></div>

                <div v-if="ifFlightSel==true" class="d-flex package-lists">

                    <div class="left-flight-info-wrap">
                        <div class="top-flight-info">
                            <div class="card info-flight ">
                           

                                    <cSelFlightInfo :isSticky="isSticky" v-if="isFlightSel" :isPayment="isPayment"
                                     :selflightObj="selFlight" @cToRemoveclassofFlight="toRemoveclassofFlight"/>
                                    <!-- <div class="info-wrap">
                                            <div class="flight-title">
                                                Depart Flight
                                            </div>
                                            <div class="flight-name">
                                                <div class="logo"><img
                                                        src="https://image.flaticon.com/icons/svg/806/806041.svg"
                                                        alt=""></div>
                                                <div class="name">
                                                    <div> Golden Myanmar Airlines</div>
                                                    <div class="d-flex flex-flow-column"><span class="flight-code"> CR - 07 </span><span
                                                            class="flight-code"> Feb 28, 2020 </span></div>
                                                </div>
                                            </div>
                                            <div class="time-place-wrap">
                                                <div class="left">
                                                    <div class="time"> 12:12</div>
                                                    <div class="place-code"> HKG</div>
                                                    <div class="place"> Hong Kong</div>
                                                </div>
                                                <div class="center"><span>4h 5m</span><img
                                                        src="/img/flying-flight.88d11502.svg"
                                                        alt=""><span>via London</span></div>
                                                <div class="right">
                                                    <div class="time"> 12:12</div>
                                                    <div class="place-code"> HKG</div>
                                                    <div class="place"> Hong Kong</div>
                                                </div>
                                            </div>
                                            <div class="luggage d-flex">
                                                <span>Class B</span>
                                            </div>
                                        </div>
                                        <div class="info-wrap">
                                            <div class="flight-title">
                                                Return Flight
                                            </div>
                                            <div class="flight-name">
                                                <div class="logo"><img
                                                        src="https://image.flaticon.com/icons/svg/806/806041.svg"
                                                        alt=""></div>
                                                <div class="name">
                                                    <div> Golden Myanmar Airlines</div>
                                                    <div class="d-flex flex-flow-column"><span class="flight-code">CR - 07</span><span
                                                            class="flight-code">Feb 28, 2020</span></div>
                                                </div>
                                            </div>
                                            <div class="time-place-wrap">
                                                <div class="left">
                                                    <div class="time"> 12:12</div>
                                                    <div class="place-code"> HKG</div>
                                                    <div class="place"> Hong Kong</div>
                                                </div>
                                                <div class="center"><span>4h 5m</span><img
                                                        src="/img/flying-flight.88d11502.svg"
                                                        alt=""><span>via London</span></div>
                                                <div class="right">
                                                    <div class="time"> 12:12</div>
                                                    <div class="place-code"> HKG</div>
                                                    <div class="place"> Hong Kong</div>
                                                </div>
                                            </div>
                                            <div class="luggage d-flex">

                                                <span>Class B</span>
                                            </div>
                                        </div> -->

<!--                                <div class="price-details-wrap">-->

<!--                                    <div class="foot">-->
<!--&lt;!&ndash;                                        <div class="left" @click="onToggleFRModal">&ndash;&gt;-->
<!--&lt;!&ndash;                                            {{$t('selFlightInfo.viewFareRules')}}&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--                                        <div class="left" @click="onToggleFRModal">-->
<!--                                            Booking Summary-->
<!--                                        </div>-->
<!--                                    </div>-->

<!--                                    <div class="search-modify-wrap ">-->

<!--                                        <div class="total-price-wrap">-->
<!--                                            <CCard >-->
<!--                                                <CCardBody  @click="ob.isObFlight?ob.isObFlight=false:ob.isObFlight=true">-->
<!--                                                <CRow v-show="ob.isObFlight==false" class="selected-ticket">-->
<!--                                                    <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.obFlight[0].flight.DepAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.obFlight[0].flight.ArrAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.clientPricing.Currency}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.clientPricing.TotalAmount | amountformat}}-->
<!--                                                </CCol>-->
<!--                                              </CRow>-->
<!--                                                    <CCollapse v-show="ob.isObFlight==true" class="mt-2">-->
<!--                                                        <cPerPaxPriceInfo :isCollapse="true" :isFooter="true"  @click="ob.isObFlight=false"-->
<!--                                                                          v-if="isFlightSel" :selflightObj="selFlight.ob"-->
<!--                                                        />-->
<!--                                                         -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;-->
<!--                                                        <CRow >-->
<!--                                                        <CCol>-->
<!--                                                           {{$t('totalpriceInfo.baseFare')}}-->
<!--                                                        </CCol>-->
<!--                                                        -->
<!--                                                        <CCol>-->
<!--                                                          {{selFlight.ob && selFlight.ob.clientPricing.Currency}}-->
<!--                                                        </CCol>-->
<!--                                                        <CCol>-->
<!--                                                       {{selFlight.ob && selFlight.ob.clientPricing.TotalBaseFare | amountformat}}-->
<!--                                                          -->
<!--                                                        </CCol>-->
<!--                                                    </CRow>-->
<!--                                                     <CRow >-->
<!--                                                        <CCol>-->
<!--                                                           {{$t('totalpriceInfo.tax')}}-->
<!--                                                        </CCol>-->
<!--                                                        -->
<!--                                                        <CCol>-->
<!--                                                          {{selFlight.ob && selFlight.ob.clientPricing.Currency}}-->
<!--                                                        </CCol>-->
<!--                                                        <CCol>-->
<!--                                                       {{selFlight.ob && selFlight.ob.clientPricing.TotalTax | amountformat}}-->
<!--                                                          -->
<!--                                                        </CCol>-->
<!--                                                    </CRow>-->
<!--                                                       -->
<!--                                                         <CRow v-show="ob.isObFlight==true" class="selected-ticket">-->
<!--                                                    <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.obFlight[0].flight.DepAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.obFlight[0].flight.ArrAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.clientPricing.Currency}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ob && selFlight.ob.clientPricing.TotalAmount | amountformat}}-->
<!--                                                </CCol>-->
<!--                                              </CRow>-->
<!--                                                    </CCollapse>-->
<!--                                                   -->
<!--                                              </CCardBody>-->
<!--                                            </CCard>-->

<!--                                             <CCard v-if="selFlight.ib!=null&&selFlight.ib.clientPricing">-->
<!--                                                 <CCardBody @click="ib.isIbFlight?ib.isIbFlight=false:ib.isIbFlight=true">-->
<!--                                                <CRow v-show="ib.isIbFlight==false" class="selected-ticket">-->
<!--                                                    <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.ibFlight[0].flight.DepAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.ibFlight[0].flight.ArrAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.clientPricing.Currency}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.clientPricing.TotalAmount | amountformat}}-->
<!--                                                </CCol>-->
<!--                                              </CRow>-->
<!--                                             -->
<!--                                                     <CCollapse v-if="selFlight.ib!=null" v-show="ib.isIbFlight==true" class="mt-2">-->
<!--                                                         <cPerPaxPriceInfo :isCollapse="true" -->
<!--                                                         :isFooter="true" @click="ib.isIbFlight=false" v-if="isFlightSel" :selflightObj="selFlight.ib"-->
<!--                                                         />-->
<!--                                                         <CRow >-->
<!--                                                        <CCol>-->
<!--                                                           {{$t('totalpriceInfo.baseFare')}}-->
<!--                                                        </CCol>-->
<!--                                                        -->
<!--                                                        <CCol>-->
<!--                                                          {{selFlight.ib && selFlight.ib.clientPricing.Currency}}-->
<!--                                                        </CCol>-->
<!--                                                        <CCol>-->
<!--                                                       {{selFlight.ib && selFlight.ib.clientPricing.TotalBaseFare | amountformat}}-->
<!--                                                          -->
<!--                                                        </CCol>-->
<!--                                                    </CRow>-->
<!--                                                     <CRow >-->
<!--                                                        <CCol>-->
<!--                                                           {{$t('totalpriceInfo.tax')}}-->
<!--                                                        </CCol>-->
<!--                                                        -->
<!--                                                        <CCol>-->
<!--                                                          {{selFlight.ib && selFlight.ib.clientPricing.Currency}}-->
<!--                                                        </CCol>-->
<!--                                                        <CCol>-->
<!--                                                       {{selFlight.ib && selFlight.ib.clientPricing.TotalTax | amountformat}}-->
<!--                                                          -->
<!--                                                        </CCol>-->
<!--                                                    </CRow>-->
<!--                                                       -->
<!--                                                         <CRow v-show="ib.isIbFlight==true" class="selected-ticket">-->
<!--                                                    <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.ibFlight[0].flight.DepAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.ibFlight[0].flight.ArrAirport}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.clientPricing.Currency}}-->
<!--                                                </CCol>-->
<!--                                                <CCol> -->
<!--                                                {{selFlight.ib && selFlight.ib.clientPricing.TotalAmount | amountformat}}-->
<!--                                                </CCol>-->
<!--                                              </CRow>-->
<!--                                                     </CCollapse>-->
<!--                                              </CCardBody>-->
<!--                                            </CCard>-->

<!--                                            &lt;!&ndash; <cPerPaxPriceInfo v-if="isFlightSel" :selflightObj="selFlight"-->
<!--                                            /> &ndash;&gt;-->

<!--                                            &lt;!&ndash; <table>-->
<!--                                                <tbody>-->
<!--                                                <tr class="active">-->
<!--                                                    <td>-->
<!--                                                        <div> Adult</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="wrapper">-->
<!--                                                            <div> x 1</div>-->
<!--                                                        </div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,222220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                                <tbody class="taxes-wrapper d-none">-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                                <tbody>-->
<!--                                                <tr class="active">-->
<!--                                                    <td>-->
<!--                                                        <div> Child</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="wrapper">-->
<!--                                                            <div> x 1</div>-->
<!--                                                        </div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                                <tbody class="taxes-wrapper d-none">-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                                <tbody>-->
<!--                                                <tr class="active">-->
<!--                                                    <td>-->
<!--                                                        <div> Infant</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="wrapper">-->
<!--                                                            <div> x 1</div>-->
<!--                                                        </div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                                <tbody class="taxes-wrapper d-none">-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                <tr>-->
<!--                                                    <td>-->
<!--                                                        <div class="taxes"> Taxes &amp; Fees</div>-->
<!--                                                    </td>-->
<!--                                                    <td></td>-->
<!--                                                    <td>-->
<!--                                                        <div class="currency">USD</div>-->
<!--                                                    </td>-->
<!--                                                    <td>-->
<!--                                                        <div class="value">22,220.00</div>-->
<!--                                                    </td>-->
<!--                                                </tr>-->
<!--                                                </tbody>-->
<!--                                            </table> &ndash;&gt;-->
<!--                                            -->
<!--                                            <cTotalPriceInfo v-if="isFlightSel" :isFooter="false"-->
<!--                                                             :selflightObj="selFlight"/>-->
<!--                                            &lt;!&ndash; <div class="total-wrap">-->
<!--                                                <div>Total</div>-->
<!--                                                <div>USD</div>-->
<!--                                                <div>280.00</div>-->
<!--                                            </div> &ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </div>

                    </div>
                </div> 
                <div class="booked-ticket-warp">
                    
                    <div class="wrapper">
                        <div class="left" style="width:210px" @click="ifFlightSel==true?ifFlightSel=false:ifFlightSel=true"> 


                            <cTotalPriceInfo  v-if="selFlight && selFlight.ob!=null ||
                                                selFlight && selFlight.ib!=null" :selflightObj="selFlight"/>

                            <div v-if="isFlightSel" class="stk-fo-arrow"><img 
                                                     src="@imgPath/img/svg/icons/down-bold-arrow.svg" alt="" v-bind:class="{active: ifFlightSel}">
                            </div>
                        </div>
                        <div v-if="isFlightSel" class="center" @click="ifFlightSel==true?ifFlightSel=false:ifFlightSel=true">
                            <CBadge color="danger">
                                {{(selFlight.ob && selFlight.ib)?2 : (selFlight.ob || selFlight.ib)? 1 : 0}}
                            </CBadge>
                            <img
                                src="@imgPath/img/svg/icons/takeoff-flight.svg" alt="">
                        </div>
                       <!-- {{isDisable}} {{tooltipText}} -->
                        <div v-show="isDisable" v-c-tooltip.hover=" {content:tooltipText?tooltipText:'Please Select Flights to continue'}"
                        class="right w-unset">
                           
                           <!-- one -->
                            <button :type="type?'submit':null" @click="onContinue()" :disabled="isDisable"
                                    class=" blue-primary-btn mt-10px continue-btn">
                                <span>{{buttonName}}</span>
                                <img src="@imgPath/img/svg/icons/correct.svg"/>
                            </button>
                        </div>
                        <div v-show="!isDisable && tooltipText==$t('passInfo.paxPageBtnTooltip')" v-c-tooltip.hover=" {content:tooltipText?tooltipText:$t('passInfo.paxPageBtnTooltip')} " class="right w-unset">
                           <!-- two -->
                            <button :type="type?'submit':null" @click="onContinue()" :disabled="isDisable"
                                    class=" blue-primary-btn mt-10px continue-btn">
                                <span>{{buttonName}}</span>
                                <img src="@imgPath/img/gif/loadandtick.gif"/>
                            </button>
                        </div>
                        <div v-show="!isDisable && tooltipText!=$t('passInfo.paxPageBtnTooltip')" class="right w-unset">
                           <!-- three -->
                            <button :type="type?'submit':null" @click="onContinue()" :disabled="isDisable"
                                    class=" blue-primary-btn mt-10px continue-btn">
                                <span>{{buttonName}}</span>
                                <img src="@imgPath/img/gif/loadandtick.gif"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cFareRule
                v-if="sSelectedPricing"
                :buttonList="[
                {name:$t('userStatus.ok'),func:onToggleFRModal,color:'success'},]"
                :show="isFRModalshow"
                :fareRuleData="sSelectedPricing.data.data.pUnits"
        ></cFareRule>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from "vuex";
    import cFareRule from "../../components/modal/cFareRule";

    import {COMPONENT_NAME, PATHNAME} from "../../util/constants";
    import cPerPaxPriceInfo from "../../components/result/cPerPaxPriceInfo"
    import cTotalPriceInfo from "../../components/result/cTotalPriceInfo";
    import cSelFlightInfo from "../../components/result/cSelFlightInfo";
    import BaseConfiguration from "../../config/base.js";
    import Logger from "../../services/logger";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";

    export default {
        name: COMPONENT_NAME.C_FILGHTFOOTER,
        components: {

            cPerPaxPriceInfo,
            cTotalPriceInfo,
            cSelFlightInfo,
            cFareRule

        },
        computed: {
            ...mapGetters("sResult", {
                sSelectedPricing: "GET_SEL_PRICING_OBJ"
            }),
        },
        props://['selflightObj'],
            {
                tooltipText:{
                   type: String,
                    default: null
                },
                isSticky: {
                    type: Boolean,
                    default: false
                },
                selFlight: {
                    type: Object | Array,
                    default: null
                },
                isDisable: {
                    type: Boolean,
                    default: false
                },
                isFlightSel: {
                    type: Boolean,
                    default: false
                },
                type: {
                    type: Boolean,
                    default: false
                },
                buttonName: {
                    type: String,
                    default: null
                },
                 isPayment:{
               type:Boolean,
              default: false
        },


            },
        data: () => ({
            isFRModalshow: false,
            ifFlightSel: false,
            obData:{
                ob:null,
                ib:null
            },
           ibData:{
                ob:null,
                ib:null
            },
            isFooter:false,
            tooltxt:'Please fill out the fields to continue',
            ob: {
      isObFlight: false
    },
    ib: {
      isIbFlight: false
    }
        }),
        created(){
            if(this.selFlight && this.selFlight.ob && this.selFlight.ib) {
            this.obData.ob=this.selFlight.ob;
            this.ibData.ib=this.selFlight.ib;
            }
        },
        methods: {
            toRemoveclassofFlight(pFlightObj,pSelFlight) {
                // let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toRemoveclassofFlight");
                  this.$emit('RemoveclassofFlight',null,pSelFlight);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_FILGHTFOOTER,
                          "error in toRemoveclassofFlight",
                          err.toString(),
                          "toRemoveclassofFlight",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                //   return retValue;
                }, 
            onToggleFRModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onToggleFRModal");
                    this.isFRModalshow = !this.isFRModalshow;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_FILGHTFOOTER,
                        "error in onToggleFRModal",
                        err.toString(),
                        "onToggleFRModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            onContinue() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("onContinue");

                    this.$emit('onContinue');
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FILGHTFOOTER,
                        "error in onContinue",
                        err.toString(),
                        "onContinue",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },
        }
    }
</script>